import zoid from 'zoid';

const zoidInit = async () => {
  // const baseUrl = process.env.NODE_ENV == "production" ? `${window.location.protocol}//${window.location.host}/` : "http://localhost:3000/";
  const baseUrl = `${window.location.protocol}//${window.location.host}/`;

  const baseUrlTag = 'asepha-url-tag';
  await zoid.create({
    tag: baseUrlTag,
    url: baseUrl,
  });
};

export default zoidInit;
